import * as Sentry from '@sentry/react';

export function addFeatureFlagExposureToSentry(experimentName: string, value: unknown): void {
	// Sentry FeatureFlagsIntegration only supports boolean flags (for now).
	if (typeof value !== 'boolean') return;

	const flagsIntegration =
		Sentry.getClient()?.getIntegrationByName<Sentry.FeatureFlagsIntegration>('FeatureFlags');
	if (flagsIntegration) {
		try {
			flagsIntegration.addFeatureFlag(experimentName, value);
		} catch (e) {
			// Something went wrong, check your DSN and/or integrations
			console.error(e);
		}
	}
}
